var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHongkong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2389 9.07819C12.9662 10.2125 12.4816 9.99619 12.2439 10.9854C10.8431 10.6486 9.9804 9.24005 10.3172 7.83919C10.6539 6.43842 12.0626 5.57573 13.4634 5.91253C12.9878 7.89099 13.4829 8.06367 13.2389 9.07819Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60408 9.91875C10.5986 10.5286 10.2431 10.9227 11.1104 11.4546C10.3572 12.6827 8.75104 13.0678 7.52283 12.3147C6.29465 11.5615 5.90948 9.95527 6.66267 8.7271C8.39733 9.79078 8.71444 9.37327 9.60408 9.91875Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28019 13.6356C10.1676 12.8782 10.4324 13.338 11.2062 12.6775C12.1416 13.7733 12.0115 15.42 10.9158 16.3553C9.81991 17.2907 8.17329 17.1605 7.23804 16.0648C8.78557 14.7437 8.48646 14.313 9.28019 13.6356Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.715 15.0921C12.2688 14.0141 12.7879 13.9043 12.3989 12.9643C13.7301 12.4133 15.256 13.0459 15.807 14.3771C16.3579 15.7083 15.7253 17.2341 14.3941 17.7851C13.6161 15.905 13.1141 16.0563 12.715 15.0921Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1617 12.2754C13.9986 12.3667 14.0544 11.8389 13.0403 11.9185C12.9276 10.4823 14.0008 9.22645 15.4371 9.11371C16.8733 9.00126 18.1291 10.0743 18.2417 11.5107C16.2131 11.6697 16.2019 12.1939 15.1617 12.2754Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHongkong);
export default __webpack_public_path__ + "static/media/hongkong.f8d89700d8d74378bcdda0a07605cc9f.svg";
export { ForwardRef as ReactComponent };